import React from 'react';

type DocumentUiConfiguration = {
  ArtifactsListLayout: React.ComponentType<any>;
  ArtifactImageLayout: React.ComponentType<any>;
  ArtifactDocumentLayout: React.ComponentType<any>;
  EmailAttachmentUploaderInput: React.ComponentType<any>;
  AttachmentsListField: React.ComponentType<any>;
  emailAttachmentArtifactTypeId: unknown;
};

const DocumentUiConfigurationContext = React.createContext<Nullable<DocumentUiConfiguration>>(null);

export const DocumentUiConfigurationProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: DocumentUiConfiguration;
}) =>
  React.createElement(DocumentUiConfigurationContext.Provider, {
    value,
    children,
  });

export const useDocumentUiConfiguration = (): DocumentUiConfiguration => {
  const documentUiConfiguration = React.useContext(DocumentUiConfigurationContext);

  if (!documentUiConfiguration) {
    throw new Error('Document UI configuration is missing');
  }

  return documentUiConfiguration;
};
